module.exports = __webpack_public_path__ + "static/pr-op-picking@3x-223f7e08dd1973ec238c92408a30ae42.png";